import type { CounselorAppointment } from '@/apiTypes'
import { useCrmStore } from '@/stores/crm'
import type { PlanData, SessionData } from '@/types'

export type SessionImport = {
	session: Partial<SessionData>
	plans: Partial<PlanData>[]
	planPrototype: Partial<PlanData>
}

export default abstract class AppointmentImporter {
	abstract import(): Promise<SessionImport>

	async getAppointmentById(
		appointmentId: string
	): Promise<CounselorAppointment> {
		const crmStore = useCrmStore()

		let appt = crmStore.findAppointment(appointmentId)

		if (!appt) {
			console.debug(
				'Could not find appointment locally with ID: ' + appointmentId
			)

			const result = await crmStore.fetchAppointment(appointmentId)
			appt = result.data

			console.debug('Loaded appt from API', appt)
		}

		return appt
	}
}
